<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">违规通报</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="isShow" placeholder="Select" style="width: 8em" @change="typeChange">
            <el-option v-for="item in isShowArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents @searchType="getSearchType($event)" @searchValue="getSearchValue($event)"/>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
          <SearchUidOrPhone style="margin-right: 16px;" @confirm="openDialog($event)"/>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
        >
          <!--          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
          <el-table-column property="createTime" label="时间" v-if="checkColList.indexOf('时间') > -1"/>
          <el-table-column property="" label="头像" v-if="checkColList.indexOf('头像') > -1" class-name="cursor" width="110">
            <template #default="scope">
              <HeadImg :images="scope.row.headImg" />
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,birth,city"/>
            </template>
          </el-table-column>
          <el-table-column prop="" label="用户状态" v-if="checkColList.indexOf('用户状态') > -1" width="200">
            <template #default="scope">
              <p>信息审核：{{scope.row.resumeState == 0 ? "未查看" : scope.row.resumeState == 1 ? "待审核" : scope.row.resumeState == 2 ? "已通过" : scope.row.resumeState == 3 ? "不通过" : "--"}}</p>
              <p>身份证认证：{{scope.row.identityAuth.overallAuthState == 0 ? "未提交" : scope.row.identityAuth.overallAuthState == 1 ? "待审核" : scope.row.identityAuth.overallAuthState == 2 ? "审核通过" : scope.row.identityAuth.overallAuthState == 3 ? "审核不通过" : ""}}</p>
              <p>微信审核：{{scope.row.wechatState == 0 ? '未提交' : scope.row.wechatState == 1 ? '待审核' : scope.row.wechatState == 2 ? '已通过' : scope.row.wechatState == 3 ? '不通过' : '--'}}</p>
              <p>是否是vip：{{scope.row.vipState == 0 ? '否' : scope.row.vipState == 1 ? '是' : scope.row.vipState == 2 ? '是' : '--'}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="通报内容" v-if="checkColList.indexOf('通报内容') > -1"></el-table-column>
          <el-table-column prop="punishResult" label="处罚结果" v-if="checkColList.indexOf('处罚结果') > -1"></el-table-column>
          <el-table-column prop="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <p>{{scope.row.isShow == 0 ? ' 待展示' : scope.row.isShow == 1 ? '展示中' : scope.row.isShow == 2 ? '隐藏' : '--'}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-button type="primary" plain size="small" @click="editDialog(scope.$index, scope.row)">编辑</el-button>
              <el-button type="success" size="small" v-show="scope.row.isShow==0 || scope.row.isShow==2" @click="updateShow(scope.$index, scope.row, 1)" v-loading="scope.row.showLoading">展示</el-button>
              <el-button type="danger" size="small" v-show="scope.row.isShow==1" @click="updateShow(scope.$index, scope.row, 2)" v-loading="scope.row.showLoading">隐藏</el-button>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getIllegalNoticePageList,updateIllegalNoticeShow
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import UserLog from "@/components/UserLog/UserLog";
import SearchUidOrPhone from '../../components/SearchUidOrPhone'
import IllegalSearchInfoDialog from "@/views/feedback/components/IllegalSearchInfoDialog";
import { common } from "@/assets/shared/select-constant";

export default {
  name: "FeedbackIllegal",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog, SearchUidOrPhone },
  data() {
    return {

      //性别
      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      isShowArray: [
        {label: '不限', value: -1},
        {label: '待展示', value: 0},
        {label: '展示中', value: 1},
        {label: '隐藏', value: 2}
      ],
      isShow: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['时间', '头像', '用户信息', '用户状态', '通报内容', '处罚结果', '状态','操作', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchRejectLoading: false,
      updateReLoading: false,
      updateNewLoading: false,

      idArray: [],

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },


    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = -1;
      this.state = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['isShow'] = this.isShow;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchValue'] = this.searchValue;
      param['searchType'] = this.searchType;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getIllegalNoticePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

    },

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },


    //搜索
    openDialog(e) {
      // console.log(e)
      Dialog.open({
        component: IllegalSearchInfoDialog,
        data: {
          userForm: e,
          idx: -1,
          width: '600px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    editDialog(idx, row) {
      // console.log(e)
      Dialog.open({
        component: IllegalSearchInfoDialog,
        data: {
          userForm: row,
          idx: idx,
          width: '600px'
        },
        confirm: (result) => {
          row['remark'] = result.remark
          row['punishResult'] = result.punishResult
        }
      })
    },

    //隐藏
    updateShow(idx, row, state) {
      this.$confirm('确定把昵称为【' + row.nickName + '】的用户' + (state == 1?'展示？':'隐藏？')).then(()=>{
        this.pageDataList[idx].showLoading = true
        let _this = this;
        let param = {};
        param['id'] = row.id;
        param['isShow'] = state;
        postFormData(updateIllegalNoticeShow, param).then((data) => {
          let {code, msg} = data;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            row.isShow = state
          }else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          _this.pageDataList[idx].showLoading = false;
        })
            .catch(()=>{
              _this.pageDataList[idx].showLoading = false;
            })
      })
    },



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
